module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("chjvG"))).then(() => parcelRequire('cvs7o'));